import { render, staticRenderFns } from "./ArticleSideBar.vue?vue&type=template&id=16148508&scoped=true&"
import script from "./ArticleSideBar.vue?vue&type=script&lang=js&"
export * from "./ArticleSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSideBar.vue?vue&type=style&index=0&id=16148508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16148508",
  null
  
)

export default component.exports